import { useState, useEffect } from 'react';

/**
 * Custom hook to check if the user is on a desktop or wider screen
 * Returns true if the screen is too small (mobile/tablet) or in portrait mode
 */
const useDesktopCheck = () => {
  const [isMobileOrPortrait, setIsMobileOrPortrait] = useState(false);

  useEffect(() => {
    const checkViewport = () => {
      const isMobile = window.innerWidth < 1024; // Tablets and below
      const isPortrait = window.innerHeight > window.innerWidth;
      setIsMobileOrPortrait(isMobile || isPortrait);
    };

    // Check on mount
    checkViewport();

    // Add event listeners for resize and orientation change
    window.addEventListener('resize', checkViewport);
    window.addEventListener('orientationchange', checkViewport);

    return () => {
      window.removeEventListener('resize', checkViewport);
      window.removeEventListener('orientationchange', checkViewport);
    };
  }, []);

  return isMobileOrPortrait;
};

export default useDesktopCheck;
